import React from "react";
import RadialChart from "./RadialChart";
import { Card, CardBody, Col, Row } from "reactstrap";

const SocialSource = ({ charts }) => {
  const sourceWise = charts?.sourceWise;
  const total = sourceWise?.total || 0;
  const items = sourceWise?.items || [
    { title: "Facebook", count: 0, icon: "mdi mdi-facebook", bgcolor: "info" },
    { title: "Google", count: 0, icon: "mdi mdi-google", bgcolor: "danger" },
  ];

  return (
    <React.Fragment>
      <Col xl={4}>
        <Card>
          <CardBody>
            <div className="d-flex align-items-center mb-1">
              <div className="flex-grow-1">
                <h5 className="card-title mb-0">Social Source</h5>
              </div>
            </div>
            {/* RadialChart */}
            <RadialChart sourceWise={sourceWise} />
            <Row className="justify-content-center">
              {items.map((item, key) => {
                const count = item.count || 0;
                const pct = total > 0 ? ((count / total) * 100).toFixed(3) : "0.000";
                return (
                  <div key={key} className="col-6">
                    <div className="social-source text-center mt-3">
                      <div className="avatar-xs mx-auto mb-2">
                        <span
                          className={
                            "avatar-title rounded-circle font-size-18 bg-" +
                            item.bgcolor
                          }
                        >
                          <i className={item.icon + " text-white"}></i>
                        </span>
                      </div>
                      <h5 className="font-size-14 mb-1">{item.title}</h5>
                      <p className="text-muted mb-0 fw-semibold">
                        {Number(count).toLocaleString()} leads
                      </p>
                      <small className="text-primary fw-semibold">{pct}% share</small>
                    </div>
                  </div>
                );
              })}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default SocialSource;
